/**
 * Returns a Date string in the form of the users locale set
 * by default on their browser. US = jan 14, 2019
 * @param {date} date - The date to be formatted
 * @param {object} options - Date formatting options.
 * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toLocaleDateString
 * @returns {string} a formatted date string
 */
export const formatDate = (
  date,
  options = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  },
) => new Date(date).toLocaleDateString(undefined, options)
